export default __webpack_public_path__ + "assets/8818cc559aecc39c2f2b8f7e13175296.png";